import styled from "styled-components";

interface Props {
    profileStatus?: any,
    visualizado: boolean
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;   
    box-shadow: 35px 45px 73px rgba(32, 32, 35, 0.07); 
`

export const NotificationWrapper = styled.div<Props>`
    display: flex;
    flex-direction: column;    
    width: 100%;
    max-width: 100%;
    min-height: 80px;
    border-left: ${({visualizado}) => (visualizado ? "none" : "4px solid #E52940")};
    background: ${({visualizado, theme}) => visualizado 
        ? (theme.colors.interfacePure0 || '#FFFFFF')
        : 'var(--cfffbfb)'};
    border-radius: 8px;
    box-shadow: ${({visualizado}) => visualizado 
        ? '0 1px 2px rgba(0, 0, 0, 0.05)'
        : '0 2px 4px rgba(229, 41, 64, 0.08)'};
    border: 1px solid ${({visualizado, theme}) => visualizado 
        ? (theme.colors.interfaceGray200 || '#E5E7EB')
        : 'rgba(229, 41, 64, 0.15)'};
    transition: box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
    box-sizing: border-box;
    position: relative;
    
    &:hover {
        box-shadow: ${({visualizado}) => visualizado 
            ? '0 4px 6px rgba(0, 0, 0, 0.1)'
            : '0 4px 8px rgba(229, 41, 64, 0.12)'};
    }
    
    .title {
        color: ${({ theme }) => theme.colors.interfaceText400 || '#64748b'};
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 4px;
    }

    .subtitle {
        color: ${({ theme }) => theme.colors.interfaceText400 || '#64748b'};
        font-size: 14px;
        font-weight: 500;
        margin: 0;
    }
    
    @media (max-width: 768px) {
        min-height: auto;
    }
`

export const NotificationTop = styled.div`
    display: grid;
    grid-template-columns: 40px 70px 1fr 2fr 180px 40px 40px;
    align-items: center;
    gap: 16px;
    min-height: 80px;
    padding: 16px 20px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    
    @media (max-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 12px 16px;
        min-height: auto;
    }
`


export const DivIcon = styled.div<Props>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    position: relative;
    justify-self: start;
    
    svg {
        width: 20px;
        height: 20px;
        path {
            fill: none;
        }
    }
    
    @media (max-width: 768px) {
        width: 32px;
        min-width: 32px;
        height: 32px;
        
        svg {
            width: 16px;
            height: 16px;
        }
    }
`

export const UnreadBadge = styled.div`
    position: absolute;
    top: -2px;
    right: -2px;
    width: 10px;
    height: 10px;
    background-color: ${(props: any) => props.theme.colors.primaryRed400};
    border-radius: 50%;
    border: 2px solid ${(props: any) => props.theme.colors.white};
    box-shadow: 0 1px 3px rgba(229, 41, 64, 0.4);
    z-index: 1;
    
    @media (max-width: 768px) {
        width: 8px;
        height: 8px;
        top: -1px;
        right: -1px;
    }
`

export const DivCode = styled.div`
    display: flex;
    align-items: center;
    justify-self: start;
    
    .subtitle {
        font-weight: 400;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.interfaceText400 || '#64748b'};
        line-height: 1.4;
    }
    
    @media (max-width: 768px) {
        min-width: 60px;
    }
`

export const DivName = styled.div<Props>`
    display: flex;
    align-items: center;
    justify-self: start;
    
    .subtitle {
        font-weight: ${({visualizado}) => visualizado ? 600 : 700};
        color: ${({visualizado, theme}) => visualizado
            ? theme.colors.interfaceText400
            : theme.colors.interfaceText500};
        word-break: break-word;
        line-height: 1.4;
    }
    
    @media (max-width: 768px) {
        max-width: 100%;
        width: 100%;
        order: 3;
    }
`

export const DivDescricao = styled.div`
    display: flex;
    align-items: center;
    justify-self: center;
    
    .subtitle {
        color: ${({ theme }) => theme.colors.interfaceText400 || '#64748b'};
        word-break: break-word;
        line-height: 1.5;
        text-align: center;
    }
    
    @media (max-width: 768px) {
        max-width: 100%;
        width: 100%;
        order: 4;
        margin-top: 4px;
        justify-self: start;
        .subtitle {
            text-align: left;
        }
    }
`

export const DivTimestamp = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    justify-self: end;
    
    .subtitle {
        color: ${({ theme }) => theme.colors.interfaceText400 || '#64748b'};
        font-size: 12px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        gap: 6px;
        justify-content: flex-end;
    }
    
    @media (max-width: 768px) {
        min-width: auto;
        text-align: left;
        order: 2;
        margin-left: auto;
        justify-self: start;
        
        .subtitle {
            font-size: 11px;
            justify-content: flex-start;
        }
    }
`


export const DivProfile = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: var(--action-square-bg);
    border-radius: 8px;
    cursor: pointer;
    justify-self: end;
    transition: background-color 0.2s ease, transform 0.1s ease;

    &:hover {
        background: var(--action-square-bg-hover);
        transform: scale(1.05);
    }
    
    &:active {
        transform: scale(0.95);
    }
    
    svg {
        width: 18px;
        height: 18px;
    }
    
    &.fake {
        background: none;
        cursor: auto;
        
        &:hover {
            transform: none;
        }
    }
    
    @media (max-width: 768px) {
        width: 36px;
        height: 36px;
        min-width: 36px;
        
        svg {
            width: 16px;
            height: 16px;
        }
    }
`
